import React from 'react';
import './Vesting.css';

const Vesting: React.FC = () => {
  return (
    <div className="vesting-page">
      <div className="page-header">
        <h1>Vesting</h1>
        <p className="page-description">View and manage your vesting schedules</p>
      </div>
      <div className="page-content">
        <div className="empty-state">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <h2>Coming Soon</h2>
          <p>Vesting management features will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default Vesting;

